import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CLBController from "../../../../services/system/clb/clb-controller";
import CLBRegisterController from "../../../../services/system/clb-register/clb-register-controller";

class ModalDeleteStudentInCLB extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: -1,
            reason: '',
            showBlock: true,
            signupInfo: null
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({
                id:  nextProps.item.id,
                name: nextProps.item?.studentRes.fullName
            })
        }
    }
    delete = () => {
        CLBRegisterController.delete(this.state.id, res => {
            if (res.success) {
                toast.success("Xóa học sinh khỏi CLB thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>

                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÔNG BÁO</b></h1>
                        </div>

                        <div className='d-flex justify-content-center mt-3 mb-3'>
                            <label className='font-size-content'>Bạn có muốn xóa <b>{this.state.name}</b> khỏi lớp CLB này không?</label>
                        </div>

                        <div className=" align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.delete()}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Hủy bỏ
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export  default  ModalDeleteStudentInCLB
